const bankList = [
  {
    bankCode: 'zfb',
    bankName: '支付寶提領'
  },
  {
    bankCode: 'wechat',
    bankName: '微信提領'
  },
  {
    bankCode: '00000',
    bankName: 'Paypal'
  },
  {
    bankCode: '004',
    bankName: '台灣銀行'
  },
  {
    bankCode: '005',
    bankName: '土地銀行'
  },
  {
    bankCode: '006',
    bankName: '合作金庫商業銀行'
  },
  {
    bankCode: '007',
    bankName: '第一商業銀行'
  },
  {
    bankCode: '008',
    bankName: '華南商業銀行'
  },
  {
    bankCode: '009',
    bankName: '彰化商業銀行'
  },
  {
    bankCode: '011',
    bankName: '上海商業儲蓄銀行'
  },
  {
    bankCode: '012',
    bankName: '台北富邦商業銀行'
  },
  {
    bankCode: '013',
    bankName: '國泰世華商業銀行'
  },
  {
    bankCode: '016',
    bankName: '高雄銀行'
  },
  {
    bankCode: '017',
    bankName: '兆豐國際商業銀行'
  },
  {
    bankCode: '018',
    bankName: '全國農業金庫'
  },
  {
    bankCode: '021',
    bankName: '花旗商業銀行'
  },
  {
    bankCode: '025',
    bankName: '首都銀行'
  },
  {
    bankCode: '039',
    bankName: '澳商澳盛銀行(荷蘭銀行)'
  },
  {
    bankCode: '040',
    bankName: '中華開發'
  },
  {
    bankCode: '048',
    bankName: '王道商業銀行'
  },
  {
    bankCode: '050',
    bankName: '台灣中小企業銀行'
  },
  {
    bankCode: '052',
    bankName: '渣打國際商業銀行'
  },
  {
    bankCode: '053',
    bankName: '台中商業銀行'
  },
  {
    bankCode: '054',
    bankName: '京城商業銀行'
  },
  {
    bankCode: '072',
    bankName: '德意志銀行'
  },
  {
    bankCode: '075',
    bankName: '東亞銀行'
  },
  {
    bankCode: '081',
    bankName: '匯豐銀行'
  },
  {
    bankCode: '101',
    bankName: '瑞興商業銀行'
  },
  {
    bankCode: '102',
    bankName: '華泰商業銀行'
  },
  {
    bankCode: '103',
    bankName: '台灣新光商業銀行'
  },
  {
    bankCode: '108',
    bankName: '陽信商業銀行'
  },
  {
    bankCode: '114',
    bankName: '基隆第一信用合作社'
  },
  {
    bankCode: '115',
    bankName: '基隆市第二信用合作社'
  },
  {
    bankCode: '118',
    bankName: '板信商業銀行'
  },
  {
    bankCode: '119',
    bankName: '淡水第一信用合作社'
  },
  {
    bankCode: '130',
    bankName: '新竹第一信用合作社'
  },
  {
    bankCode: '132',
    bankName: '新竹第三信用合作社'
  },
  {
    bankCode: '146',
    bankName: '台中市第二信用合作社'
  },
  {
    bankCode: '147',
    bankName: '三信商業銀行'
  },
  {
    bankCode: '158',
    bankName: '彰化第一信用合作社'
  },
  {
    bankCode: '162',
    bankName: '彰化第六信用合作社'
  },
  {
    bankCode: '165',
    bankName: '彰化縣鹿港信用合作社'
  },
  {
    bankCode: '215',
    bankName: '花蓮第一合作信用社'
  },
  {
    bankCode: '216',
    bankName: '花蓮第二合作信用社'
  },
  {
    bankCode: '583',
    bankName: '台南市東山區農會'
  },
  {
    bankCode: '600',
    bankName: '財團法人全國農漁業及金融資訊中心'
  },
  {
    bankCode: '619',
    bankName: '高雄市燕巢區農會信用部'
  },
  {
    bankCode: '700',
    bankName: '中華郵政股份有限公司'
  },
  {
    bankCode: '803',
    bankName: '聯邦商業銀行'
  },
  {
    bankCode: '805',
    bankName: '遠東國際商業銀行'
  },
  {
    bankCode: '806',
    bankName: '元大商業銀行'
  },
  {
    bankCode: '807',
    bankName: '永豐商業銀行'
  },
  {
    bankCode: '808',
    bankName: '玉山商業銀行'
  },
  {
    bankCode: '809',
    bankName: '凱基商業銀行'
  },
  {
    bankCode: '810',
    bankName: '星展銀行(寶華商業銀行)'
  },
  {
    bankCode: '812',
    bankName: '台新國際商業銀行'
  },
  {
    bankCode: '814',
    bankName: '大眾銀行'
  },
  {
    bankCode: '815',
    bankName: '日盛國際商業銀行'
  },
  {
    bankCode: '816',
    bankName: '安泰商業銀行'
  },
  {
    bankCode: '822',
    bankName: '中國信託商業銀行'
  },
  {
    bankCode: '910',
    bankName: '財團法人農漁業會聯合資訊中心'
  },
  {
    bankCode: '928',
    bankName: '板橋區農會電腦共用中心'
  },
  {
    bankCode: '951',
    bankName: '新北市農會附設北區農會電腦共同利用中心'
  },
  {
    bankCode: '952',
    bankName: '財團法人農漁業會南區資訊中心'
  },
  {
    bankCode: '957',
    bankName: '中華民國信用合作社聯合社南區聯合資訊處理中心'
  }
];

export default bankList;
